// import Vue from 'vue'
import server from '../../api/server'
import StoreClasses from './StoreClasses'

// import moment from 'moment'

const state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  tags: [],
  searchSet: new StoreClasses.ItemSet(item => item.ref.ref, {
    search: '',
    tagIds: [],
    isShowOther: false
  }),
  favoriteSet: new StoreClasses.ItemSet(item => item.ref.ref + '_' + item.accountId, {
    search: '',
    tagIds: [],
    isShowOther: false
  }),
  monitoringSet: new StoreClasses.ItemSet(item => item.ref.ref, {
    search: '',
    tagIds: [],
    isShowOther: false
  })
}

// getters
const getters = {
  getSearchSet: state => state.searchSet,
  getFavoriteSet: state => state.favoriteSet,
  getMonitoredSet: state => state.monitoringSet,
  getFavoriteShowOther: state => state.favoriteSet.filter.isShowOther,
  getTags: state => state.tags
}

// actions
const actions = {
  fetchSearchCompanies ({commit, state, getters}, force) {
    const fetchcall = (params) => {
      // const cb = (count, data) => data.last ? 0 : count - data.numberOfElements
      return new Promise((resolve, reject) => {
        commit('startSearchCompanies')
        if (getters.getProfileHaveClient) {
          if (params && params.request && !params.request.search) {
            server.apiGetParams(
                '/api/me/visited/companies', params,
            (data) => {
              commit('setSearchCompanies', {data: data, cxt: fxt})
              commit('setSuccessStatus')
              resolve()
            },
            (e) => {
              commit('stopSearchCompanies')
              commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка компаний  '})
            })
          } else {
            server.apiGetParams(
                '/api/me/search/companies', params,
            (data) => {
              commit('setSearchCompanies', {data: data, cxt: fxt})
              commit('setSuccessStatus')
              resolve()
            },
            (e) => {
              commit('stopSearchCompanies')
              commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка компаний  '})
            })
          }
        } else {
          server.openApiGetParams(
              '/openapi/companies', params,
          (data) => {
            commit('setSearchCompanies', {data: data, cxt: fxt})
            commit('setSuccessStatus')
            resolve()
          },
          (e) => {
            commit('stopSearchCompanies')
            commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка компаний  '})
          })
        }
      })
    }
    if (!force && !state.searchSet.isChanged()) {
      return
    }
    commit('closeAlert')
    let page = force ? 0 : state.searchSet.page
    let fxt = Object.assign({}, getters.getSearchSet.getFilter())
    let size = 20
    let startLoaded = state.searchSet.getLoadedSize()
    let limitLoaded = startLoaded + size / 2
    const loop = () => {
      if (!state.searchSet.isLast() &&
        (startLoaded <= state.searchSet.getLoadedSize()) &&
        (state.searchSet.getLoadedSize() < limitLoaded)) {
        fetchcall({size: size, page: page++, request: {search: fxt.search}})
            .then(() => loop())
      }
    }
    loop()
  },
  fetchFavoriteCompanies ({commit, state, getters}, force) {
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    if (!force && !state.favoriteSet.isChanged()) {
      return
    }
    var page = force ? 0 : state.favoriteSet.page
    var fxt = Object.assign({}, getters.getFavoriteSet.getFilter())
    commit('startFavoriteCompanies')
    server.apiGetParams(
      '/api/me/favorite/companies',
      {
        size: 100,
        page: page,
        request: {
          search: fxt.search,
          tagIds: fxt.tagIds,
          isShowOther: fxt.isShowOther,
          isMonitoring: false
        }
      },
      (data) => {
        commit('setFavoriteCompanies', {data: data, cxt: fxt})
        commit('setSuccessStatus')
      },
      (e) => {
        commit('stopFavoriteCompanies')
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  '})
      }
    )
  },
  fetchMonitoredCompanies ({commit, state, getters}, force) {
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    if (!force && !state.monitoringSet.isChanged()) {
      return
    }
    var page = force ? 0 : state.monitoringSet.page
    var fxt = Object.assign({}, getters.getMonitoredSet.getFilter())
    commit('startMonitoredCompanies')
    server.apiGetParams(
      '/api/me/favorite/companies',
      {
        size: 100,
        page: page,
        request: {
          search: fxt.search,
          tagIds: fxt.tagIds,
          isShowOther: false,
          isMonitoring: true
        }
      },
      (data) => {
        commit('setMonitoredCompanies', {data: data, cxt: fxt})
        commit('setSuccessStatus')
      },
      (e) => {
        commit('stopMonitoredCompanies')
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  '})
      }
    )
  },
  getCompanyProps ({commit, state, getters}, refCode) {
    return new Promise((resolve, reject) => {
      const cb = (data) => { resolve(data) }
      const cbError = (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о компании из ЕГРЮЛ '})
      }
      server.openApiGet(
        '/openapi/companies/' + refCode,
        cb,
        cbError)
    })
  },
  getFavoriteRefs ({commit, state, getters}, refCode) {
    if (!(getters.getProfileLoaded && getters.getProfileHaveClient === true)) {
      return
    }
    return new Promise((resolve, reject) => {
      const cb = (data) => { resolve(data) }
      const cbError = (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о компании из ЕГРЮЛ '})
      }
      server.apiGet(
        '/api/me/favorites/' + refCode,
        cb,
        cbError)
    })
  },
  addFavoriteCompany ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/favorite/companies/',
      {refCode: request.refCode, tagIds: request.tagIds},
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении контрагента в избранное '})
      }
    )
  },
  addFavoriteCompanies ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/favorite/command-companies-adds',
      {refCodes: request.refCodes, tagIds: request.tagIds},
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении контрагента в избранное '})
      }
    )
  },
  deleteFavoriteCompany ({commit, state, rootState}, refCode) {
    server.apiDelete(
      '/api/me/favorite/companies/' + refCode,
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении контрагента из избранного '})
      }
    )
  },
  deleteFavoriteCompanies ({commit, state, rootState}, requests) {
    server.apiPost(
      '/api/me/favorite/command-companies-deletes',
      {refCodes: requests.refCodes},
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении контрагента в избранное '})
      }
    )
  },
  updateFavoriteCompanyNotes ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/favorite/companies/' + request.refCode + '/command-notes-updates',
      {notes: request.notes, privateNotes: request.privateNotes},
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении примечания компании '})
      }
    )
  },
  switchClientMonitoring ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/monitoring/command-monitoring-switches',
      {monitoring: request.monitoring, addFavorites: request.addFavorites},
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
        this.dispatch('fetchAccountProfile')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении режима мониторинга '})
      }
    )
  },
  updateMonitoringCompanies ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/monitoring/command-monitoring-updates',
      {refCodes: request.refCodes, monitoring: request.monitoring},
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменения режима мониторинга для компании '})
      }
    )
  },
  updateFavoriteCompanyTags ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/favorite/companies/' + request.refCode + '/command-tags-updates',
      {tags: request.tags},
      (data) => {
        this.dispatch('fetchFavoriteCompanies', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении меток компании '})
      }
    )
  },
  fetchTags ({commit, state}, force) {
    if (state.tags.length > 0 && !force) {
      return
    }
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    server.apiGet(
      '/api/me/tags',
      (data) => {
        commit('setTags', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка меток клиента  '})
      }
    )
  },
  getCompanyBanks ({commit, state, rootState}, refCode) {
    return new Promise((resolve, reject) => {
      server.apiGet(
      '/api/me/favorites/' + refCode + '/banks',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка банковских счетов компании  '})
        }
      )
    })
  },
  getCompanyBank ({commit, state, rootState}, id) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/companyBanks/' + id,
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении банковского счета'})
        }
      )
    })
  },

  updateCompanyBank ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/companies/command-bank-updates',
        {dto: request.dto},
        (data) => {
          this.dispatch('fetchFavoriteCompanies', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении банкоасктх реквизитов компании '})
        }
      )
    })
  },
  deleteCompanyBank ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/companies/command-bank-deletes',
        {ids: request.ids},
        (data) => {
          this.dispatch('fetchFavoriteCompanies', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении записей о контактах '})
        }
      )
    })
  },
  getCompanyContacts ({commit, state, rootState}, refCode) {
    return new Promise((resolve, reject) => {
      server.apiGet(
      '/api/me/favorites/' + refCode + '/contacts',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка контактов компании  '})
        }
      )
    })
  }
}

// mutations
const mutations = {
  setSearchFilterContext (state, cxt) {
    state.searchSet.setFilter(cxt)
  },
  startSearchCompanies (state) {
    state.searchSet.clearChanged()
    state.searchSet.start()
  },
  stopSearchCompanies (state) {
    state.searchSet.stop()
  },
  nextSearchCompanies (state) {
    state.searchSet.nextPage()
  },
  setSearchCompanies (state, {data, cxt}) {
    state.searchSet.setItems(data, cxt)
    state.searchSet.stop()
  },
  setFavoritesFilterContext (state, cxt) {
    state.favoriteSet.setFilter(cxt)
  },
  startFavoriteCompanies (state) {
    state.favoriteSet.clearChanged()
    state.favoriteSet.start()
  },
  stopFavoriteCompanies (state) {
    state.favoriteSet.stop()
  },
  nextFavoriteCompanies (state) {
    state.favoriteSet.nextPage()
  },
  setFavoriteCompanies (state, {data, cxt}) {
    state.favoriteSet.setItems(data, cxt)
    state.favoriteSet.stop()
  },
  setMonitoredFilterContext (state, cxt) {
    state.monitoringSet.setFilter(cxt)
  },
  startMonitoredCompanies (state) {
    state.monitoringSet.clearChanged()
    state.monitoringSet.start()
  },
  stopMonitoredCompanies (state) {
    state.monitoringSet.stop()
  },
  nextMonitoredCompanies (state) {
    state.monitoringSet.nextPage()
  },
  setMonitoredCompanies (state, {data, cxt}) {
    state.monitoringSet.setItems(data, cxt)
    state.monitoringSet.stop()
  },
  setTags (state, data) {
    state.tags = data.sort((a, b) => a.name.localeCompare(b.name))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/favorite.js